 import { styled } from "@mui/material/styles";

 const StyledOrderHistory = styled("div")(
  ({ theme }) => `
  .order-history-container-wrap {
    padding: 50px 8%;
    @media screen and (max-width: 600px) {
      padding: 20px 8%;
    }
  }
  .order-history-header {
    display: flex;
    align-items: center;
    gap: 10px;
    @media screen and (max-width: 600px) {
      justify-content: space-between;
    }
    
  }
  .back-btn-order-header {
    display: flex;
    gap: 10px;
    align-items: center;
  }  
  .order-history-title {
    font-family: Lexend;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
    @media screen and (max-width: 600px) {
      font-size: 18px;
    }
  } 
  .order-history-container {
    display: flex;
    gap: 30px;
    margin-top: 20px;
  }
  .order-history-filter {
    width: 20%;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 600px) {
      display: none;
    }
  }
  .order-history-orders {
    width: 70%;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }         
  .filter-title {
    font-family: Lexend;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    color: ${theme.palette.primary.main};
  }
  .filter-by-date-range-heading {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.primary.main};
    margin-top: 20px;
  }
  .filter-status-header {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.primary.main};
  }  
  .filter-by-order-status {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 10px;
  }  
  .order-status-tag {
    border: 0.8px solid ${theme.palette.customColor.secondaryThird};
    color: ${theme.palette.primary.main};
    width: fit-content;
    padding: 8px 10px;
    height: auto;
    cursor: pointer;
  }
  .selected { 
    background-color: ${theme.palette.secondary.main};
    color: ${theme.palette.customColor.white};
    border-color: ${theme.palette.secondary.main};
  }  
  .filter-btns {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .filter-btn {
    display: none;
    gap: 5px;
    align-items: center;
    text-transform: none;
    border-radius: 0px;
    @media screen and (max-width: 600px) {
      display: flex;
    }
  }  
  .cancel-all-btn {
    border: 1px solid ${theme.palette.primary.main};
    color: ${theme.palette.primary.main};
    text-transform: none;
    border-radius: 0px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
  }
  .apply-filter-btn {
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.customColor.white};
    text-transform: none;
    border-radius: 0px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
  }
  .order-status-tag-text {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
  }  
  .date-range-picker {
    width: 100%;
    
    .rs-picker-toggle {
      cursor: pointer !important;
      padding: 8px 12px;
      border-radius: 4px;
      border: 1px solid ${theme.palette.customColor.secondaryThird};
      
      &:hover {
        border-color: ${theme.palette.secondary.main};
      }
      
      /* Add this to style the selected date text */
      .rs-picker-toggle-value {
        font-size: 14px;
        font-weight: 400;
        font-family: 'Lexend', sans-serif;
        color: ${theme.palette.primary.main};
      }
    }
  
    .rs-calendar-header-title,
    .rs-calendar-header-title-date,
    .rs-calendar-table-cell-selected .rs-calendar-table-cell-content,
    .rs-calendar-table-cell-selected:hover .rs-calendar-table-cell-content {
      color: ${theme.palette.secondary.main} !important;
    }
    
    .rs-calendar-table-cell-in-range::before {
      background-color: ${theme.palette.secondary.main}20 !important;
    }
    
    .rs-calendar-table-cell-selected .rs-calendar-table-cell-content,
    .rs-calendar-table-cell-selected:hover .rs-calendar-table-cell-content {
      background-color: ${theme.palette.secondary.main} !important;
    }
    
    .rs-btn-primary {
      background-color: ${theme.palette.secondary.main} !important;
      color: white !important;
    }
    
    .rs-picker-toolbar-right-btn-ok {
      background-color: ${theme.palette.secondary.main} !important;
    }
  }

  .rs-input-group.rs-input-group-inside{
  border-radius: 0px !important;
  width: 100% !important;
 }
.rs-calendar-table-cell-selected .rs-calendar-table-cell-content,
.rs-calendar-table-cell-selected:hover .rs-calendar-table-cell-content {
  background-color: #A78D78 !important;
  color: white !important;
}

  :global(.rs-picker-menu) {
    .rs-calendar-header-title,
    .rs-calendar-header-title-date,
    .rs-calendar-header-title:hover,
    .rs-calendar-header-backward:hover,
    .rs-calendar-header-forward:hover {
      color: ${theme.palette.secondary.main} !important;
    }
  }
  .filter-modal-container {
    background-color: ${theme.palette.customColor.white};
    width: 100%;
    height: auto;
    padding: 20px;
    position: absolute;
    top: 0%;
    left: 0%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 30px;
    border: none !important;
  }
  .load-more-btn-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 50px 0px;
  }
  .load-more-btn {
    border: 1px solid ${theme.palette.primary.main};
    color: ${theme.palette.primary.main};
    text-transform: none;
    border-radius: 0px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    padding: 10px 20px;
  }
  .date-range-picker .rs-picker-toggle {
  flex-direction: row-reverse;
}

.date-range-picker .rs-picker-toggle .rs-picker-toggle-clean {
  order: 2;
}

.date-range-picker .rs-picker-toggle .rs-picker-toggle-caret {
  order: 1;
  margin-right: 8px;
  margin-left: 0;
}        
.total-orders-heading {
  font-family: Lexend;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: ${theme.palette.primary.main};
}  
.rs-picker-daterange-menu .rs-picker-toolbar > div:nth-child(1) {
  display: none;
}  
`
);

export default StyledOrderHistory;

